import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { merge, Subject, tap } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'y42-checkbox-cell-renderer',
  templateUrl: './checkbox-cell-renderer.component.html',
  styleUrls: ['./checkbox-cell-renderer.component.scss'],
})
export class CheckboxCellRendererComponent implements ICellRendererAngularComp {
  constructor() {
    this.twoWayBindingSelectionChange().pipe(untilDestroyed(this)).subscribe();
  }

  protected readonly checkboxFC = new FormControl<boolean>(false, { nonNullable: true });

  private params?: ICellRendererParams;

  private readonly updateSelectionDataToUi$$ = new Subject<void>();
  private readonly updateSelectionUiToData$$ = this.checkboxFC.valueChanges;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.updateSelectionDataToUi$$.next();
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.updateSelectionDataToUi$$.next();
    return true;
  }

  private twoWayBindingSelectionChange() {
    return merge(
      this.updateSelectionDataToUi$$.pipe(
        tap(() => {
          if (!this.params) {
            return;
          }
          const isDataSelected = this.params.value;
          const isUiSelected = this.checkboxFC.value;
          if (isUiSelected !== isDataSelected) {
            this.checkboxFC.setValue(isDataSelected);
          }
        }),
      ),
      this.updateSelectionUiToData$$.pipe(
        tap(() => {
          if (!this.params) {
            return;
          }
          const isUiSelected = this.checkboxFC.value;
          const isDataSelected = this.params.value;
          if (isDataSelected !== isUiSelected) {
            const colId = this.params.column?.getColId();
            if (colId) {
              this.params.node.setDataValue(colId, isUiSelected);
            }
          }
        }),
      ),
    );
  }
}
